import { createSlice } from '@reduxjs/toolkit'
import { ErrorState } from 'types/store'

const initialState: ErrorState = {
  error: undefined,
}

const { reducer, actions } = createSlice({
  name: 'response',
  initialState,
  reducers: {
    setError: (_state, { payload }) => ({
      error: payload,
    }),
    reset: () => ({
      error: undefined,
    }),
  },
})

export default reducer
export { actions }
